import React from 'react';
import '../styles/UnitToggle.css';

const UnitToggle = ({ leftLabel, rightLabel, checked, onChange, id, disabled = false }) => {
  // Generate a unique ID if one isn't provided
  const toggleId = id || `unitToggle-${Math.random().toString(36).substr(2, 9)}`;
  
  // Add a direct handler to ensure the event is being passed correctly
  const handleChange = (e) => {
    console.log('UnitToggle: onChange event triggered', e.target.checked);
    // Pass the boolean checked state to the onChange prop function
    onChange(e.target.checked);
  };
  
  return (
    <div className={`toggle-container ${disabled ? 'disabled' : ''}`}>
      <span className="unit-label-left">{leftLabel}</span>
      <label className="switch">
        <input 
          type="checkbox" 
          id={toggleId}
          name={toggleId}
          checked={checked} 
          onChange={handleChange} 
          disabled={disabled}
        />
        <span className="slider round"></span>
      </label>
      <span className="unit-label-right">{rightLabel}</span>
    </div>
  );
};

export default UnitToggle;
